module.exports = __webpack_public_path__ + "img/139.49a863db.jpg";